import React from 'react';
import './MobileNav.css';

const MobileNav = ({ activeTab, setActiveTab, currentPath, navigate }) => {
    const navItems = [
        { key: 'withdrawal', icon: '💸', label: 'Withdraw', path: '/dashboard/withdrawal' },
        { key: 'matches', icon: '🎮', label: 'Matches', path: '/dashboard/matches' },
        { key: 'registrations', icon: '📋', label: 'My Games', path: '/dashboard/registrations' },
        { key: 'results', icon: '🏆', label: 'Results', path: '/dashboard/results' },
        // { key: 'withdrawal', icon: '💸', label: 'Withdraw' }, // Might be too many items?
        { key: 'profile', icon: '👤', label: 'Profile', path: '/dashboard/profile' }
    ];

    const handleClick = (item) => {
        console.log('MobileNav Click:', item.key);
        if (typeof navigate === 'function') {
            // Router Mode
            if (item.key === 'home') {
                navigate('/');
            } else if (item.path) {
                navigate(item.path);
            } else {
                console.error('No path for item:', item);
            }
        } else if (typeof setActiveTab === 'function') {
            // State Mode
            setActiveTab(item.key);
        } else {
            console.error('MobileNav: No valid navigation method (navigate or setActiveTab)');
        }
    };

    const isActive = (item) => {
        if (currentPath) {
            if (item.key === 'home' && (currentPath === '/' || currentPath === '/dashboard')) return true;
            return currentPath.includes(item.key); // simple matching
        }
        return activeTab === item.key;
    };

    return (
        <nav className="mobile-nav">
            {navItems.map((item) => (
                <button
                    key={item.key}
                    className={`mobile-nav-item ${isActive(item) ? 'active' : ''}`}
                    onClick={() => handleClick(item)}
                >
                    <span className="mobile-nav-icon">{item.icon}</span>
                    <span className="mobile-nav-label">{item.label}</span>
                </button>
            ))}
        </nav>
    );
};

export default MobileNav;
